/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
//import logo from '../assets/images/logoFS.png';
import fondoFS from '../assets/images/logo_FS_TALENTO_2.png';
import '../styles/home.css';
import msgNotificacion from '../scripts/notification';
import msgAlerta from '../scripts/alert';

// Material MUI
import {
  Button,
  Tooltip,
  Grid,
  Stack,
  // Autocomplete,
  // TextField,
  // List,
  // ListItem,
  // ListItemText,
  // ListItemAvatar,
  // IconButton,
  // Avatar,
  // Divider
} from '@mui/material';

// Material Icons
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

// Components
import Heading from '../components/heading/Heading';
import CustomAlerts from '../components/alert/CustomAlerts';
import { isMobile, isDesktop } from 'react-device-detect';

// Redux
import { useDispatch } from 'react-redux';
import { showProgress } from '../redux/reducers/progress.Slice';
import { NAME_PROJECT, ROLES_REG_UBICACION } from '../redux/constants';

// Services
import HomeService from '../services/homeService';

export default function Home() {
  const dispatch = useDispatch()
  const [latitude, setLatitude] = useState(null)
  const [longitude, setLongitude] = useState(null)
  const [message, setMessage] = useState(null)
  const [title, setTitle] = useState(null)
  const [openMessage, setOpenMensaje] = useState(false)
  const [severity, setSeverity] = useState('error')
  const [hiddenLocation, setHiddenLocation] = useState(true)
  const userLogin = JSON.parse(localStorage.getItem('user'))

  const getLocation = () => {
    try {
      if (navigator.geolocation) {
        // Configurar opciones para mejorar la precisión
        const options = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        };

        navigator.geolocation.getCurrentPosition(successCallback, errorCallback, options)
        setOpenMensaje(false)
      } else {
        setOpenMensaje(true)
        setMessage('La geolocalización no es compatible con este navegador.')
        setTitle('Error al obtener la localización.')
      }
    } catch (error) {
      console.error(error)
    }
  }

  const successCallback = (position) => {
    try {
      dispatch(showProgress(true))

      setTimeout(() => {
        setLatitude(position.coords.latitude)
        setLongitude(position.coords.longitude)

        dispatch(showProgress(false))        
        setMessage('Ubicación obtenida correctamente.')
        setTitle(null)
        setSeverity('success')
      }, 1000)

    } catch (error) {
      console.error(error)
    }
  }

  const errorCallback = (error) => {
    try {
      setOpenMensaje(true)
      setTitle('Error al obtener la localización.')
      setMessage(error.message)
    } catch (error) {
      console.error(error)
    }
  }

  const saveLocation = async () => {
    try {
      if (!longitude && !latitude) {
        setOpenMensaje(true)
        setMessage('Clic en obtener ubicación antes de Registrar.')
        setTitle('Error al registrar ubicación.')
        return
      }

      const data = {
        codEmpleado: userLogin.CodigoEmpleado,
        codEmpresa: 'FSRA',
        latitud: latitude.toString(),
        longitud: longitude.toString(),
        dispositivo: isMobile ? 'Móvil' : isDesktop ? 'Computadora' : 'Tablet'
      }      

      dispatch(showProgress(true))

      HomeService.saveLocationEmployee(data)
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            dispatch(showProgress(false))
            return
          }

          setTimeout(() => {
            if (response.Codigo === 1) {
              setHiddenLocation(true)
              setOpenMensaje(false)
              setLongitude(null)
              setLatitude(null)
              
              msgAlerta('Exito!', response.Mensaje, 'success')
            } else {
              setOpenMensaje(true)
              setMessage(response.Mensaje)
              setTitle('Error al registrar ubicación.')
            }

            dispatch(showProgress(false))
          }, 1000)
        })
        .catch((error) => {
          console.error(error)
        })
    } catch (error) {
      console.error(error)
    }
  }

  const accessData = () => {
    try {
      
      if (ROLES_REG_UBICACION.includes(userLogin.CodigoRol)) {
        setHiddenLocation(false)
      } else {        
        setHiddenLocation(true)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const getComprobante = async () => {
    try {
      dispatch(showProgress(true))
      const urlPath = process.env.REACT_APP_API_URL;
      //const urlPath = 'http://192.168.5.48:81';
      const comprobanteEmp = `Comprobante_${userLogin.CodigoEmpleado}`;
      const fileUrl = `${urlPath}/RRHH/Comprobantes/${comprobanteEmp}.pdf`;

      const response = await fetch(fileUrl);
      console.log(response)

      if (response.status !== 200) {
        msgAlerta('Error al obtener comprobante de Pago', 'Su comprobante no fue encontrado en el directorio', 'warning')
        dispatch(showProgress(false))
        return
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.style.display = 'none';
      a.href = url;
      a.download = `${comprobanteEmp}.pdf`;

      document.body.appendChild(a);

      a.click();
      window.URL.revokeObjectURL(url);

      setTimeout(() => {
        dispatch(showProgress(false))
      }, 500)
    } catch (error) {
      dispatch(showProgress(false))
      console.error(error)
    }
  }

  useEffect(() => {
    document.title = `Home - ${NAME_PROJECT}`
    const access = localStorage.getItem('noAutorizado')

    if (access) {
      msgNotificacion('No tiene autorizado el acceso a esta URL. Contacte al administrador del Sitio', 'warning')
      localStorage.removeItem('noAutorizado')
    }

    dispatch(showProgress(true))

    setTimeout(() => {
      accessData()
      dispatch(showProgress(false))
    }, 500)
  }, [])

  return <div className='App-content'>
    <Heading className='mt-0 py-0 w-100 heading justify-content-center text-transform-none'>
      <div className='heading-text flex-column w-100'>
        <i className='bx bxs-home'></i>
        <span>Página de Inicio</span>

        <Stack>
          <Tooltip title='Descagar comprobante de Pago'>
            <Button
              variant='contained'
              className='text-transform-none me-2 btn-refresh-marc'
              color='info'
              startIcon={<FileDownloadIcon />}
              onClick={() => getComprobante()}
              size='small'
              hidden={true}
            >
              Descargar comprobante
            </Button>
          </Tooltip>
        </Stack>

      </div>
    </Heading>

    <Grid container backgroundColor='#f0f0f0'>
      <Stack width='100%' marginY={1} marginX={1} hidden={hiddenLocation}>
        <Stack direction='row' width='100%' spacing={1} className=''>
          <Tooltip title='Obtener ubicación'>
            <Button
              variant='contained'
              className='text-transform-none w-100 button-home'
              color='info'
              startIcon={<LocationSearchingIcon />}
              onClick={() => getLocation()}
              size='small'
            >
              Obtener ubicación
            </Button>
          </Tooltip>
          <Tooltip title='Registrar ubicación'>
            <Button
              variant='contained'
              className='text-transform-none w-100 button-home'
              color='success'
              startIcon={<MoreTimeIcon />}
              onClick={() => saveLocation()}
              size='small'
            >
              Registrar marcación
            </Button>
          </Tooltip>

        </Stack>
      </Stack>

      <span className='text-center text-default w-100'>
        {latitude && longitude && (
          <span className='text-center'>
            Latitud: <strong className='text-success'>{latitude.toFixed(10)}</strong>
            <br />
            Longitud: <strong className='text-success'>{longitude.toFixed(10)}</strong>
          </span>
        )}
      </span>
       
      <CustomAlerts
        severity={severity}
        message={message || ''}
        title={title}
        open={openMessage}
        setOpen={setOpenMensaje}
      />

    </Grid>

    <div className='dv-home'>
      <img src={fondoFS} alt='logo FS' className='img-home' />
    </div>
  </div>
}